<template>
  <v-layout row wrap justify-center>
    <v-flex xs12>
      <div v-if="is_owner && !hasWinners" justify-space-around class="text-xs-center mt-3">
        <set-winners></set-winners>
      </div>
      <div v-if="hasWinners" justify-space-around class="text-xs-center mt-3">
        <podium
          :team_1="winners[0]? winners[0] : null"
          :team_2="winners[1]? winners[1] : null"
          :team_3="winners[2]? winners[2] : null"
        ></podium>
      </div>
      <v-subheader>ESTATÍSTICAS</v-subheader>
      <v-card style="border-radius: 10px">
        <v-tabs v-model="statisticTabs" grow>
          <v-tab v-for="(title, index) in tabsTitles" :key="index">
            <v-icon :color="title.color">{{title.icon}}</v-icon>
          </v-tab>
          <v-tabs-items v-model="statisticTabs" touchless>
            <v-tab-item lazy v-for="(title, index) in tabsTitles" :key="index">
              <v-card style="border-radius: 10px">
                <v-card-text class="px-0">
                  <v-toolbar-title
                    :class="[`${title.color}--text`, 'text-xs-center']"
                  >{{title.name}}</v-toolbar-title>
                  <v-data-table
                    :headers="headersData"
                    :items="allStats? allStats : []"
                    hide-actions
                    v-if="headersData!='' && headersData!=null"
                  >
                    <template slot="items" slot-scope="props">
                      <td class="text-xs-center px-0">{{ props.index+1 }}</td>
                      <td
                        v-if="statisticTabs!=1"
                        class="text-xs-center px-0"
                      >{{ props.item.player_name }}</td>
                      <td class="text-xs-center px-0">{{ props.item.team_name }}</td>
                      <td
                        v-if="statisticTabs==0"
                        class="text-xs-center px-0"
                      >{{ props.item.total_goals }}</td>
                      <td
                        v-if="statisticTabs==1"
                        class="text-xs-center px-0"
                      >{{ Math.floor(props.item.against_per_game) }}</td>
                      <td
                        v-if="statisticTabs==1"
                        class="text-xs-center px-0"
                      >{{ props.item.total_goals_against }}</td>
                      <td
                        v-if="statisticTabs==1"
                        class="text-xs-center px-0"
                      >{{ props.item.games_played }}</td>
                      <td
                        v-if="statisticTabs==2"
                        class="text-xs-center px-0"
                      >{{ props.item.total_yellow_cards }}</td>
                      <td
                        v-if="statisticTabs==2"
                        class="text-xs-center px-0"
                      >{{ props.item.total_red_cards }}</td>
                    </template>
                  </v-data-table>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";

export default {
  components: {
    SetWinners: () => import("@/components/Championships/Winners/SetWinners"),
    Podium: () => import("@/components/Championships/Winners/Podium")
  },
  props: {
    edition_modality_id: {
      type: Number
    }
  },
  data() {
    return {
      search: "",
      statisticTabs: 0,
      tabsTitles: [
        { name: "Artilharia", icon: "mdi-soccer", color: "primary" },
        { name: "Melhor Defesa", icon: "mdi-shield-plus", color: "blue" },
        { name: "Cartões", icon: "mdi-cards", color: "purple" }
        // suspender e desuspender jogador manualmente
        // colocar btn para zerar os cartoes (para mudar de grupos/mata-mata)
      ],
      pagination: {
        sortBy: "goals_scored",
        descending: true,
        rowsPerPage: -1
      } // -1 for All
    };
  },
  computed: {
    is_owner() {
      return this.oneChampionship.data.attributes.can_edit;
    },
    GoalsAgainst() {
      return [5, 10];
    },
    headersData() {
      var header = [];
      if (this.statisticTabs == 0) {
        header = [
          {
            text: "P.",
            align: "center",
            value: "index",
            width: "5%",
            sortable: false
          },
          {
            text: "Atleta",
            align: "center",
            value: "name",
            sortable: false,
            width: "45%"
          },
          {
            text: "Equipe",
            align: "center",
            value: "team",
            sortable: false,
            width: "45%"
          },
          {
            text: "Gols",
            align: "center",
            value: "total_goals",
            sortable: false,
            width: "5%"
          }
        ];
      } else if (this.statisticTabs == 1) {
        header = [
          {
            text: "P.",
            align: "center",
            value: "position",
            sortable: false,
            width: "1%"
          },
          {
            text: "Equipe",
            align: "center",
            value: "team",
            sortable: false,
            width: "20%"
          },
          {
            text: "GS/J",
            align: "center",
            value: "goals_against",
            sortable: false,
            width: "1%"
          },
          {
            text: "GS",
            align: "center",
            value: "goals_against",
            sortable: false,
            width: "1%"
          },
          {
            text: "J",
            align: "center",
            value: "games_played",
            sortable: false,
            width: "1%"
          }
        ];
      } else if (this.statisticTabs == 2) {
        header = [
          {
            text: "P.",
            align: "center",
            value: "position",
            sortable: false,
            width: "1%"
          },
          {
            text: "Atleta",
            align: "center",
            value: "name",
            sortable: false,
            width: "47%"
          },
          {
            text: "Equipe",
            align: "center",
            value: "team",
            sortable: false,
            width: "47%"
          },
          {
            text: "Ama.",
            align: "center",
            value: "total_goals",
            sortable: false,
            width: "1%"
          },
          {
            text: "Ver.",
            align: "center",
            value: "total_goals",
            sortable: false,
            width: "1%"
          }
        ];
      }
      return header;
    },
    ...mapState({
      allStats: state => state.Championship.allStats,
      oneChampionship: state => state.Championship.oneChampionship
    }),
    ...mapGetters({
      winners: "Championship/winners",
      hasWinners: "Championship/hasWinners"
    })
  },
  methods: {
    getname(item) {
      return "teste";
    },
    ...mapActions({
      indexStats: "Championship/indexStatistics"
    })
  },
  watch: {
    statisticTabs(nv, ov) {
      if (nv != null) {
        this.indexStats({ params: { kind: nv, id: this.$route.params.id } });
      } else if (nv == false) {
      }
    }
  },
  mounted() {
    this.indexStats({
      params: { kind: this.statisticTabs, id: this.$route.params.id }
    });
  }
};
</script>

<style scoped>
.CardUser {
  padding: 20px;
}
</style>


